<template>
  <div class="m-4">
    <h2 class="text-center">Confirm Device Return</h2>
    <hr>
    <div class="row">
      <div class="col-auto">
        <i class="fas fa-exclamation-circle fa-8x m-4"></i>
      </div>
      <div class="col">
        <h3>{{ device.barcode }} - {{ device.manufacturer }} {{ device.model }}</h3>
        <p class="alert alert-warning">Before clicking <strong>Confirm</strong> check that you have the correct device &amp; user</p>
        <dl class="row">
          <dt class="col-sm-4 text-right">
            <span v-if="isCivilian">HTS Username</span>
            <span v-else>Service Number</span>
          </dt>
          <dd class="col-sm-8">{{ loan.service_number }}</dd>
          <dt class="col-sm-4 text-right">Name</dt>
          <dd class="col-sm-8">{{ loan.name }}</dd>
          <dt class="col-sm-4 text-right">Signed Out</dt>
          <dd class="col-sm-8">
            <app-date-time v-if="loan.start_date" :date-str="loan.start_date" />
            <span v-else>Never</span>
          </dd>
        </dl>
        <hr>
        <div class="form-group row">
          <div class="col-12 col-sm-5 col-md-3 col-form-label text-right font-weight-bold">Device Status</div>
          <div class="col-12 col-sm">
            <div class="row">
              <div class="col-12 my-1">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="checklistDeviceYes" name="checklistDevice" class="custom-control-input" v-model="checklist.device" :value="false">
                  <label class="custom-control-label" for="checklistDeviceYes">Working</label>
                </div>
              </div>
              <div class="col-12 my-1">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="checklistDeviceNo" name="checklistDevice" class="custom-control-input" v-model="checklist.device" :value="true">
                  <label class="custom-control-label" for="checklistDeviceNo">Damaged or Lost</label>
                </div>
              </div>
            </div>
            <small class="form-text text-muted">
              Check the device is free from any attributable damage
            </small>
          </div>
        </div>

        <div class="form-group row mt-4">
          <div class="col-sm-5 col-md-3 col-form-label text-right font-weight-bold">Accessories</div>
          <div class="col-sm">
            <div class="row">
              <div class="col-12 my-1">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="checklistAccessoriesYes" name="checklistAccessories" class="custom-control-input" v-model="checklist.accessories" :value="false">
                  <label class="custom-control-label" for="checklistAccessoriesYes">All Returned</label>
                </div>
              </div>
              <div class="col-12 my-1">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="checklistAccessoriesNo" name="checklistAccessories" class="custom-control-input" v-model="checklist.accessories" :value="true">
                  <label class="custom-control-label" for="checklistAccessoriesNo">Missing or Lost</label>
                </div>
              </div>  
            </div>
            <small class="form-text text-muted">
              Check the appropriate accessories (e.g. charger) have been returned with the device
            </small>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12 col-sm-5 col-md-3 col-form-label text-right font-weight-bold">Return Notes</div>
          <div class="col-12 col-sm">
            <app-textarea id="notes" rows="3" v-model.trim="checklist.note" />
            <small class="form-text text-muted">
              Once a device has been returned, notes can no longer be added
            </small>
          </div>
        </div>
      </div>
    </div>
    
    <div class="text-center mt-4"> 
      <ul class="list-inline">
        <li class="list-inline-item"><button class="btn btn-danger" :disabled="!checklistComplete" @click.prevent="handleManualReturn">Confirm</button></li>
        <li class="list-inline-item"><button class="btn btn-dark" @click.prevent="handleCancel">Cancel</button></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { xhrState } from '@/components/mixins/xhrState'

import api from '@/api'

export default {
  name: 'ManualReturnModal',
  mixins: [xhrState],
  props: {
    device: {
      type: Object,
      required: true
    },
    loan: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checklist: {
        device: null,
        accessories: null,
        note: ''
      },
    }
  },
  computed: {
    isCivilian() {
      return this.loan.service_number.toUpperCase().startsWith('HTS-')
    },
    checklistComplete() {
      return Object.values(this.checklist).every(item => item != null)
    }
  },
  methods: {
    async handleManualReturn() {
      try {
        this.setLoadingState()
        const manualReturnRequest = await api.devices.returnDevice(this.device.id, this.checklist)

        if (manualReturnRequest.status === 200) {
          this.setReadyState()
        }
      } catch {
        this.setErrorState()
        return
      }

      // Reset confirmation required flag
      this.showConfirm = true
      // Close modal
      this.$modal.hide('confirmReturnModal')
      // Reload route
      this.$router.go()
    },
    handleCancel() {
      this.$emit('close')
    }
  }
}
</script>
